import { render } from "./CalendarRegistration.vue?vue&type=template&id=87692054&scoped=true"
import script from "./CalendarRegistration.vue?vue&type=script&lang=js"
export * from "./CalendarRegistration.vue?vue&type=script&lang=js"

import "./CalendarRegistration.vue?vue&type=style&index=0&id=87692054&scoped=true&lang=css"

import exportComponent from "/Users/jinming/Documents/jhapps/frontendadmin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-87692054"]])

export default __exports__